var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangebg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "url(#paint0_linear)",
    stroke: "#FEFEFE",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4,
    y1: 6,
    x2: 26.5,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522222,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangebg);
export default __webpack_public_path__ + "static/media/changebg.89d428e2.svg";
export { ForwardRef as ReactComponent };var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangebg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15,
    fill: "url(#paint0_linear)",
    stroke: "#FEFEFE",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 4,
    y1: 6,
    x2: 26.5,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522222,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangebg);
export default __webpack_public_path__ + "static/media/changebg.89d428e2.svg";
export { ForwardRef as ReactComponent };